import { ConnectionStatus } from "@2stand-events/chat-client";
import React from "react";
import { useTranslation } from "../../hooks";
import useConnectionStatus from "../../hooks/useConnectionStatus";
import S from "./Status.styled";
const Status = () => {
    const strings = useTranslation();
    const status = useConnectionStatus();
    const statusText = () => {
        switch (status) {
            case ConnectionStatus.Disconnected:
                return strings.statusDisconnected;
            case ConnectionStatus.Connecting:
                return strings.statusConnecting;
            case ConnectionStatus.DisconnectedRetrying:
                return strings.statusTryingToReconnect;
            default:
                return "";
        }
    };
    return (React.createElement(S.Wrapper, { "data-testid": "status", hidden: status === ConnectionStatus.Connected }, statusText()));
};
export default Status;
//# sourceMappingURL=Status.js.map